import styled from '@emotion/styled';
import { useResource } from '@landsbankinn/l16n';
import { NotFound as NotFoundIcon, typography } from '@landsbankinn/ui';
import React from 'react';
import res from './NotFound.res';

const Host = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

const Text = styled.p`
  ${typography.body}
  opacity: 60%;
`;

const StyledNotFoundIcon = styled(NotFoundIcon)`
  height: 93px;
  margin-bottom: 24px;
`;

export const NotFound: React.FC = () => {
  const { r } = useResource();
  return (
    <Host>
      <StyledNotFoundIcon />
      <Text>{r(res.notfound)}</Text>
    </Host>
  );
};
